// src/pages/TheTeam.js
// Brand story page — who we are and what drives Maison D'Oud.

import React from 'react';
import { Award, Globe, Heart } from 'lucide-react';
import usePageTitle from '../hooks/usePageTitle';

const TheTeam = () => {
    usePageTitle(
        'Who We Are',
        'Meet the team behind MAISON D\'OUD. Three people, one shared obsession with premium concentrated perfume oils.',
        'maison d\'oud team, about us, our story'
    );

    return (
        <div className="bg-background min-h-screen pt-32 pb-24 px-6 transition-colors duration-300">
            <div className="max-w-7xl mx-auto">

                {/* Page heading */}
                <div className="text-center mb-16">
                    <h1 className="text-5xl md:text-6xl font-light text-foreground mb-6 tracking-wide">
                        Who We Are
                    </h1>
                    <p className="text-muted-foreground text-lg max-w-2xl mx-auto leading-relaxed">
                        Three people. One shared obsession. Giving the world access to premium concentrated perfume oils the way they were always meant to be worn.
                    </p>
                </div>

                {/* Brand pillars */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="bg-card rounded-2xl p-8 border border-border hover:border-[#CEAC8F]/30 transition-all">
                        <div className="w-12 h-12 bg-[#CEAC8F]/10 rounded-full flex items-center justify-center mb-6">
                            <Award className="w-6 h-6 text-[#CEAC8F]" />
                        </div>
                        <h3 className="text-foreground text-xl font-light mb-3">Bold Presence</h3>
                        <p className="text-muted-foreground leading-relaxed">
                            We don't create background scents. Each fragrance commands attention, a presence that announces your arrival and lingers in memory long after you have left.
                        </p>
                    </div>

                    <div className="bg-card rounded-2xl p-8 border border-border hover:border-[#CEAC8F]/30 transition-all">
                        <div className="w-12 h-12 bg-[#CEAC8F]/10 rounded-full flex items-center justify-center mb-6">
                            <Globe className="w-6 h-6 text-[#CEAC8F]" />
                        </div>
                        <h3 className="text-foreground text-xl font-light mb-3">A Lasting Standard</h3>
                        <p className="text-muted-foreground leading-relaxed">
                            Rooted in centuries of Middle Eastern fragrance tradition. Concentrated oils built to stay with you, not fade on you.
                        </p>
                    </div>

                    <div className="bg-card rounded-2xl p-8 border border-border hover:border-[#CEAC8F]/30 transition-all">
                        <div className="w-12 h-12 bg-[#CEAC8F]/10 rounded-full flex items-center justify-center mb-6">
                            <Heart className="w-6 h-6 text-[#CEAC8F]" />
                        </div>
                        <h3 className="text-foreground text-xl font-light mb-3">Your Signature</h3>
                        <p className="text-muted-foreground leading-relaxed">
                            Not reserved for occasions. Worn daily, as a mark of standard. Your scent is your calling card, the mark you leave behind.
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default TheTeam;